import { takeLatest, put, call } from "redux-saga/effects";
import fetchAPI, { ApiResponse } from "../../../utils/api";
import loginPageSlice from "../../login-page/store/slice";
import userFilterSlice, { UserFilters } from "./slice";

type UserFilterResponse = ApiResponse<{ data: UserFilters[] }>;

function* userFiltersSaga() {
  yield takeLatest(loginPageSlice.actions.setLoggedIn, handleFetchData);
  yield takeLatest(userFilterSlice.actions.fetchData, handleFetchData);
}

function* handleFetchData() {
  const response: UserFilterResponse = yield call(fetchAPI, `/user/filters`);

  if (response && response.data) {
    yield put(userFilterSlice.actions.setData(response.data));
  }

  yield put(userFilterSlice.actions.setIsLoading(false));
}

export default userFiltersSaga;
